<script setup>
import Modal from '@/components/Modal.vue';
import { onMounted, ref } from 'vue';
import { Howl } from 'howler';
import { IconTrophyFilled } from '@tabler/icons-vue';
import ConfettiExplosion from 'vue-confetti-explosion';

const show = ref(false);
const showConfetti = ref(false);

defineProps({
    message: {
        type: String,
    },
});

onMounted(() => {
    show.value = true;

    setTimeout(() => {
        const sound = new Howl({
            src: ['/assets/gamification/victory.mp3'],
        });
        sound.play();
    }, 1500);
    setTimeout(() => {
        showConfetti.value = true;
    }, 2000);
});
</script>

<template>
    <Modal :show="show" @close="show = false">
        <div class="flex justify-center">
            <span>{{ message }}</span>
        </div>
        <div class="flex justify-center">
            <IconTrophyFilled class="h-20 w-20 text-yellow-400" />
        </div>
    </Modal>
    <Teleport to="body">
        <div class="relative z-20 pointer-events-none">
            <div class="fixed z-10 inset-0">
                <div class="flex items-center justify-center min-h-full p-4">
                    <ConfettiExplosion v-if="showConfetti" />
                </div>
            </div>
        </div>
    </Teleport>
</template>
